// API client for portal backend
// Replace static data calls with API calls to Lambda functions

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";
// Individual function URLs (set these after deployment)
// These take precedence over API_BASE_URL when set
const REQUEST_RESET_URL = import.meta.env.VITE_REQUEST_RESET_URL || "";
const CONFIRM_RESET_URL = import.meta.env.VITE_CONFIRM_RESET_URL || "";
const REGISTER_URL = import.meta.env.VITE_REGISTER_URL || "";
const LOGIN_URL = import.meta.env.VITE_LOGIN_URL || "";
const VERIFY_TOKEN_URL = import.meta.env.VITE_VERIFY_TOKEN_URL || "";
const LIST_MODULES_URL = import.meta.env.VITE_LIST_MODULES_URL || "";
const GET_MODULE_URL = import.meta.env.VITE_GET_MODULE_URL || "";
const GET_LESSONS_URL = import.meta.env.VITE_GET_LESSONS_URL || "";
const COMPLETE_LESSON_URL = import.meta.env.VITE_COMPLETE_LESSON_URL || "";
const GET_PROGRESS_URL = import.meta.env.VITE_GET_PROGRESS_URL || "";
const LIST_ASSESSMENTS_URL = import.meta.env.VITE_LIST_ASSESSMENTS_URL || "";
const SUBMIT_ASSESSMENT_URL = import.meta.env.VITE_SUBMIT_ASSESSMENT_URL || "";
const LIST_INSIGHTS_URL = import.meta.env.VITE_LIST_INSIGHTS_URL || "";
const AI_INSIGHTS_URL = import.meta.env.VITE_AI_INSIGHTS_URL || "";
const LIST_RESOURCES_URL = import.meta.env.VITE_LIST_RESOURCES_URL || "";
const LIST_SESSIONS_URL = import.meta.env.VITE_LIST_SESSIONS_URL || "";
const LIST_LEADERSHIP_ARTICLES_URL = import.meta.env.VITE_LIST_LEADERSHIP_ARTICLES_URL || "";
const GET_LEADERSHIP_ARTICLE_URL = import.meta.env.VITE_GET_LEADERSHIP_ARTICLE_URL || "";
const GET_SETTINGS_URL = import.meta.env.VITE_GET_SETTINGS_URL || "";
const UPDATE_SETTINGS_URL = import.meta.env.VITE_UPDATE_SETTINGS_URL || "";
const GET_APP_CONFIG_URL = import.meta.env.VITE_GET_APP_CONFIG_URL || "";
const UPDATE_PROFILE_URL = import.meta.env.VITE_UPDATE_PROFILE_URL || "";
const SAVE_NOTE_URL = import.meta.env.VITE_SAVE_NOTE_URL || "";
const GET_NOTE_URL = import.meta.env.VITE_GET_NOTE_URL || "";
const GET_PAYMENTS_URL = import.meta.env.VITE_GET_PAYMENTS_URL || "";
const SAVE_EXERCISE_URL = import.meta.env.VITE_SAVE_EXERCISE_URL || "";
const GET_EXERCISE_URL = import.meta.env.VITE_GET_EXERCISE_URL || "";
const TRACK_EVENT_URL = import.meta.env.VITE_TRACK_EVENT_URL || "";
const LIST_EVENTS_URL = import.meta.env.VITE_LIST_EVENTS_URL || "";
const EMAIL_TRIGGER_EVENT_URL = import.meta.env.VITE_EMAIL_TRIGGER_EVENT_URL || "";
const LIST_ACTIVITIES_URL = import.meta.env.VITE_LIST_ACTIVITIES_URL || "";
const GET_ACTIVITY_RESPONSE_URL = import.meta.env.VITE_GET_ACTIVITY_RESPONSE_URL || "";
const SAVE_ACTIVITY_RESPONSE_URL = import.meta.env.VITE_SAVE_ACTIVITY_RESPONSE_URL || "";
// Course management URLs
const LIST_COURSES_URL = import.meta.env.VITE_LIST_COURSES_URL || "";
const GET_COURSE_URL = import.meta.env.VITE_GET_COURSE_URL || "";
const GET_USER_COURSES_URL = import.meta.env.VITE_GET_USER_COURSES_URL || "";
const SELECT_COURSE_URL = import.meta.env.VITE_SELECT_COURSE_URL || "";
const ADMIN_COURSES_URL = import.meta.env.VITE_ADMIN_COURSES_URL || "";

// AI Future Work Toolkit / Newsletter URLs
const SUBSCRIBE_NEWSLETTER_URL = import.meta.env.VITE_SUBSCRIBE_NEWSLETTER_URL || "";
const SUBMIT_FREE_RESOURCE_URL = import.meta.env.VITE_SUBMIT_FREE_RESOURCE_URL || "";
const VERIFY_FREE_RESOURCE_URL = import.meta.env.VITE_VERIFY_FREE_RESOURCE_URL || "";
const UNSUBSCRIBE_NEWSLETTER_URL = import.meta.env.VITE_UNSUBSCRIBE_NEWSLETTER_URL || "";
const CHECK_RESOURCE_ACCESS_URL = import.meta.env.VITE_CHECK_RESOURCE_ACCESS_URL || "";
const REQUEST_ACCESS_LINK_URL = import.meta.env.VITE_REQUEST_ACCESS_LINK_URL || "";

// Salary Edge URLs
const SALARY_CREATE_SURVEY_URL = import.meta.env.VITE_CREATE_SALARY_SURVEY_URL || "";
const SALARY_GET_SURVEY_URL = import.meta.env.VITE_GET_SALARY_SURVEY_URL || "";
const SALARY_GET_SURVEYS_BY_EMAIL_URL = import.meta.env.VITE_GET_SALARY_SURVEYS_BY_EMAIL_URL || "";
const SALARY_GET_SURVEYS_BY_USER_URL = import.meta.env.VITE_GET_SALARY_SURVEYS_BY_USER_URL || "";
const SALARY_LINK_SURVEYS_URL = import.meta.env.VITE_LINK_SALARY_SURVEYS_URL || "";
const SALARY_GENERATE_REPORT_URL = import.meta.env.VITE_GENERATE_SALARY_REPORT_URL || "";
const SALARY_GET_REPORT_URL = import.meta.env.VITE_GET_SALARY_REPORT_URL || "";
const SALARY_GET_REPORTS_BY_USER_URL = import.meta.env.VITE_GET_SALARY_REPORTS_BY_USER_URL || "";
const SALARY_SAVE_PARTIAL_URL = import.meta.env.VITE_SAVE_PARTIAL_SALARY_SURVEY_URL || "";
const SALARY_RESUME_SURVEY_URL = import.meta.env.VITE_RESUME_SALARY_SURVEY_URL || "";
const SALARY_RESEND_EMAIL_URL = import.meta.env.VITE_RESEND_SALARY_REPORT_EMAIL_URL || "";
const SALARY_REFINE_REPORT_URL = import.meta.env.VITE_REFINE_SALARY_REPORT_URL || "";
const ADMIN_GET_AI_USAGE_URL = import.meta.env.VITE_ADMIN_GET_AI_USAGE_URL || "";

// Survey Response Tracking URLs
const SUBMIT_SURVEY_RESPONSE_URL = import.meta.env.VITE_SUBMIT_SURVEY_RESPONSE_URL || "";
const GET_SURVEY_RESPONSES_URL = import.meta.env.VITE_GET_SURVEY_RESPONSES_URL || "";
const GET_USER_PROFILE_INSIGHTS_URL = import.meta.env.VITE_GET_USER_PROFILE_INSIGHTS_URL || "";
const LINK_SURVEY_RESPONSES_URL = import.meta.env.VITE_LINK_SURVEY_RESPONSES_URL || "";

// Admin-only Survey Response URLs
const ADMIN_GET_ALL_SURVEY_RESPONSES_URL = import.meta.env.VITE_ADMIN_GET_ALL_SURVEY_RESPONSES_URL || "";
const ADMIN_GET_SURVEY_RESPONSES_BY_EMAIL_URL = import.meta.env.VITE_ADMIN_GET_SURVEY_RESPONSES_BY_EMAIL_URL || "";
const ADMIN_GET_PROFILE_INSIGHTS_BY_EMAIL_URL = import.meta.env.VITE_ADMIN_GET_PROFILE_INSIGHTS_BY_EMAIL_URL || "";

interface ApiResponse<T> {
  data?: T;
  error?: string;
}

class ApiClient {
  private baseUrl: string;
  private token: string | null = null;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    // Load token from localStorage
    if (typeof window !== "undefined") {
      this.token = localStorage.getItem("auth_token");
    }
  }

  setToken(token: string | null) {
    this.token = token;
    if (token && typeof window !== "undefined") {
      localStorage.setItem("auth_token", token);
    } else if (typeof window !== "undefined") {
      localStorage.removeItem("auth_token");
    }
  }

  private async request<T>(
    endpoint: string,
    options: RequestInit = {},
    useFullUrl: boolean = false
  ): Promise<ApiResponse<T>> {
    const url = useFullUrl ? endpoint : `${this.baseUrl}${endpoint}`;
    const headers: HeadersInit = {
      "Content-Type": "application/json",
      ...options.headers,
    };

    if (this.token) {
      headers["Authorization"] = `Bearer ${this.token}`;
    }

    try {
      const response = await fetch(url, {
        ...options,
        headers,
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ error: "Request failed" }));
        return { error: error.error || `HTTP ${response.status}` };
      }

      const data = await response.json();
      return { data };
    } catch (error) {
      return { error: error instanceof Error ? error.message : "Network error" };
    }
  }

  // Authentication
  async register(email: string, password: string, name: string) {
    const url = REGISTER_URL || `${this.baseUrl}/auth/register`;
    return this.request<{ token: string; user: any }>(url, {
      method: "POST",
      body: JSON.stringify({ email, password, name }),
    }, !!REGISTER_URL);
  }

  async login(email: string, password: string) {
    const url = LOGIN_URL || `${this.baseUrl}/auth/login`;
    return this.request<{ token: string; user: any }>(url, {
      method: "POST",
      body: JSON.stringify({ email, password }),
    }, !!LOGIN_URL);
  }

  async verifyToken() {
    const url = VERIFY_TOKEN_URL || `${this.baseUrl}/auth/verify`;
    return this.request<{ valid: boolean; user?: any }>(url, {}, !!VERIFY_TOKEN_URL);
  }

  async requestPasswordReset(email: string) {
    // Use dedicated function URL if available, otherwise use base URL
    const url = REQUEST_RESET_URL ||
      import.meta.env.VITE_REQUEST_PASSWORD_RESET_URL ||
      `${this.baseUrl}/auth/reset-password/request`;
    return this.request<{ message: string }>(url, {
      method: "POST",
      body: JSON.stringify({ email }),
    }, true); // true = use full URL
  }

  async confirmPasswordReset(token: string, newPassword: string, name?: string) {
    // Use dedicated function URL if available, otherwise use base URL
    const url = CONFIRM_RESET_URL ||
      import.meta.env.VITE_CONFIRM_PASSWORD_RESET_URL ||
      `${this.baseUrl}/auth/reset-password/confirm`;
    return this.request<{ message: string }>(url, {
      method: "POST",
      body: JSON.stringify({ token, newPassword, name }),
    }, true); // true = use full URL
  }

  // Modules
  async getModules(courseId?: string) {
    const baseUrl = LIST_MODULES_URL || `${this.baseUrl}/modules`;
    const url = courseId
      ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}courseId=${courseId}`
      : baseUrl;
    return this.request<{ modules: any[] }>(url, {}, !!LIST_MODULES_URL);
  }

  async getModule(moduleId: string) {
    const url = GET_MODULE_URL ? `${GET_MODULE_URL}?id=${moduleId}` : `${this.baseUrl}/modules/${moduleId}`;
    return this.request<any>(url, {}, !!GET_MODULE_URL);
  }

  // Lessons
  async getLessons(moduleId: string, lessonId?: string) {
    const baseUrl = GET_LESSONS_URL || `${this.baseUrl}/lessons`;
    const url = lessonId
      ? `${baseUrl}?moduleId=${moduleId}&lessonId=${lessonId}`
      : `${baseUrl}?moduleId=${moduleId}`;
    return this.request<{ lessons?: any[]; lesson?: any; progress?: any }>(url, {}, !!GET_LESSONS_URL);
  }

  // Progress
  async completeLesson(lessonId: string, progress?: number) {
    const url = COMPLETE_LESSON_URL || `${this.baseUrl}/progress/complete`;
    return this.request<{ message: string; completed: boolean; progress: number }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ lessonId, progress }),
      },
      !!COMPLETE_LESSON_URL
    );
  }

  async getProgress() {
    const url = GET_PROGRESS_URL || `${this.baseUrl}/progress`;
    return this.request<{
      overall: any;
      modules: Record<string, any>;
      progress: any[];
    }>(url, {}, !!GET_PROGRESS_URL);
  }

  // Assessments
  async getAssessments() {
    const url = LIST_ASSESSMENTS_URL || `${this.baseUrl}/assessments`;
    return this.request<{ assessments: any[] }>(url, {}, !!LIST_ASSESSMENTS_URL);
  }

  async getAssessment(lessonId?: string, assessmentId?: string) {
    const baseUrl = LIST_ASSESSMENTS_URL || `${this.baseUrl}/assessments`;
    const params = new URLSearchParams();
    if (lessonId) params.append("lessonId", lessonId);
    if (assessmentId) params.append("assessmentId", assessmentId);
    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    return this.request<{ assessment: any }>(url, {}, !!LIST_ASSESSMENTS_URL);
  }

  async submitAssessment(assessmentId: string, answers: Record<string, any>) {
    const url = SUBMIT_ASSESSMENT_URL || `${this.baseUrl}/assessments/submit`;
    return this.request<{ message: string; responseId: string; insight?: string; insightMeta?: any }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ assessmentId, answers, status: "completed" }),
      },
      !!SUBMIT_ASSESSMENT_URL
    );
  }

  async saveAssessmentDraft(
    assessmentId: string,
    answers: Record<string, any>,
    currentIndex: number
  ) {
    const url = SUBMIT_ASSESSMENT_URL || `${this.baseUrl}/assessments/submit`;
    return this.request<{ message: string; responseId: string }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({
          assessmentId,
          answers,
          status: "in_progress",
          currentIndex,
        }),
      },
      !!SUBMIT_ASSESSMENT_URL
    );
  }

  // Insights
  async getInsights(courseId?: string) {
    const baseUrl = LIST_INSIGHTS_URL || `${this.baseUrl}/insights`;
    const url = courseId
      ? `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}courseId=${courseId}`
      : baseUrl;
    return this.request<{ insights: any[] }>(url, {}, !!LIST_INSIGHTS_URL);
  }

  async generateAiInsight(payload: {
    activityId: string;
    activityTitle?: string;
    activityType?: "pre-work" | "assessment";
    activityDescription?: string;
    microAction?: string;
    answers: Record<string, any>;
    baselineInsight?: string;
  }) {
    const url = AI_INSIGHTS_URL || `${this.baseUrl}/insights/ai`;
    return this.request<{ insight: any }>(
      url,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      !!AI_INSIGHTS_URL
    );
  }

  // Resources
  async getResources(category?: string, courseId?: string) {
    const baseUrl = LIST_RESOURCES_URL || `${this.baseUrl}/resources`;
    const params = new URLSearchParams();
    if (category) params.append("category", category);
    if (courseId) params.append("courseId", courseId);

    const queryString = params.toString();
    const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    return this.request<{ resources: any[] }>(url, {}, !!LIST_RESOURCES_URL);
  }

  // Leadership Articles
  async getLeadershipArticles() {
    const url = LIST_LEADERSHIP_ARTICLES_URL || `${this.baseUrl}/leadership-articles`;
    return this.request<{ articles: any[] }>(url, {}, !!LIST_LEADERSHIP_ARTICLES_URL);
  }

  async getLeadershipArticle(slug: string) {
    const baseUrl = GET_LEADERSHIP_ARTICLE_URL || `${this.baseUrl}/leadership-articles`;
    const url = `${baseUrl}?slug=${encodeURIComponent(slug)}`;
    return this.request<{ article: any }>(url, {}, !!GET_LEADERSHIP_ARTICLE_URL);
  }

  // Sessions
  async getSessions(courseId?: string) {
    const baseUrl = LIST_SESSIONS_URL || `${this.baseUrl}/sessions`;
    const url = courseId
      ? `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}courseId=${courseId}`
      : baseUrl;
    return this.request<{ sessions: any[] }>(url, {}, !!LIST_SESSIONS_URL);
  }

  // Settings
  async getSettings() {
    const url = GET_SETTINGS_URL || `${this.baseUrl}/settings`;
    return this.request<{ settings: any }>(url, {}, !!GET_SETTINGS_URL);
  }

  async updateSettings(preferences: any) {
    const url = UPDATE_SETTINGS_URL || `${this.baseUrl}/settings`;
    return this.request<{ message: string }>(url, {
      method: "PUT",
      body: JSON.stringify(preferences),
    }, !!UPDATE_SETTINGS_URL);
  }

  // Global app config (feature flags, etc.)
  async getAppConfig() {
    const url = GET_APP_CONFIG_URL || `${this.baseUrl}/config`;
    return this.request<{ config: { communityEnabled: boolean } }>(url, {}, !!GET_APP_CONFIG_URL);
  }

  // Profile
  async updateProfile(profile: { name: string }) {
    if (UPDATE_PROFILE_URL) {
      return this.request<{ message: string; user: any }>(
        UPDATE_PROFILE_URL,
        {
          method: "PUT",
          body: JSON.stringify(profile),
        },
        true
      );
    }

    // Fallback to base URL routing if configured
    if (!this.baseUrl) {
      return { error: "Profile API URL not configured" };
    }

    return this.request<{ message: string; user: any }>(
      "/profile",
      {
        method: "PUT",
        body: JSON.stringify(profile),
      },
      false
    );
  }

  // Notes
  async getNotes(lessonId?: string) {
    const baseUrl = GET_NOTE_URL || `${this.baseUrl}/notes`;
    const url = lessonId ? `${baseUrl}?lessonId=${lessonId}` : baseUrl;
    return this.request<{ notes?: Record<string, any>; note?: any }>(url, {}, !!GET_NOTE_URL);
  }

  async saveNote(lessonId: string, content: string) {
    const url = SAVE_NOTE_URL || `${this.baseUrl}/notes`;
    return this.request<{ message: string }>(url, {
      method: "POST",
      body: JSON.stringify({ lessonId, content }),
    }, !!SAVE_NOTE_URL);
  }

  // Stripe Checkout
  async createCheckoutSession(
    product: "cohort" | "upsell" | "course",
    email: string = "",
    name?: string,
    successUrl?: string,
    cancelUrl?: string,
    courseId?: string,
    courseSlug?: string
  ) {
    const CHECKOUT_URL = import.meta.env.VITE_CHECKOUT_FUNCTION_URL || "";
    const url = CHECKOUT_URL || `${this.baseUrl}/checkout`;

    return this.request<{ id: string; url: string }>(url, {
      method: "POST",
      body: JSON.stringify({
        product,
        email,
        name,
        successUrl: successUrl || `${window.location.origin}/checkout/success?product=${product}`,
        cancelUrl: cancelUrl || `${window.location.origin}/checkout?canceled=true`,
        courseId,
        courseSlug
      }),
    }, !!CHECKOUT_URL);
  }

  // Payments
  async getPayments() {
    const url = GET_PAYMENTS_URL || `${this.baseUrl}/payments`;
    return this.request<{ payments: any[] }>(url, {}, !!GET_PAYMENTS_URL);
  }

  // Exercises
  async getExercise(lessonId?: string) {
    const baseUrl = GET_EXERCISE_URL || `${this.baseUrl}/exercises`;
    // Don't make request if URL is not properly configured
    if (!GET_EXERCISE_URL && !this.baseUrl) {
      return { error: "Exercise API URL not configured" };
    }
    const url = lessonId ? `${baseUrl}?lessonId=${lessonId}` : baseUrl;
    return this.request<{
      exercise?: {
        responses: Record<string, string>;
        status: "in_progress" | "completed";
        currentStep?: number;
        insight?: any;
      };
      exercises?: any[]
    }>(url, {}, !!GET_EXERCISE_URL);
  }

  async saveExercise(
    lessonId: string,
    responses: Record<string, string>,
    currentStep?: number,
    status?: "in_progress" | "completed"
  ) {
    const url = SAVE_EXERCISE_URL || `${this.baseUrl}/exercises`;
    // Don't make request if URL is not properly configured
    if (!SAVE_EXERCISE_URL && !this.baseUrl) {
      return { error: "Exercise API URL not configured" };
    }
    return this.request<{ message: string; status: string; insight?: any }>(url, {
      method: "POST",
      body: JSON.stringify({ lessonId, responses, currentStep, status }),
    }, !!SAVE_EXERCISE_URL);
  }

  // Leadership diagnostics (Activities)
  async getActivities(category?: "pre-work" | "assessment", courseId?: string) {
    const baseUrl = LIST_ACTIVITIES_URL || `${this.baseUrl}/activities`;
    const params = new URLSearchParams();
    if (category) params.append("category", category);
    if (courseId) params.append("courseId", courseId);

    const queryString = params.toString();
    const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    return this.request<{ activities: any[] }>(url, {}, !!LIST_ACTIVITIES_URL);
  }

  async getActivityResponses(activityId?: string) {
    const baseUrl = GET_ACTIVITY_RESPONSE_URL || `${this.baseUrl}/activities/responses`;
    const url = activityId ? `${baseUrl}?activityId=${encodeURIComponent(activityId)}` : baseUrl;
    return this.request<{ response?: any; responses?: any[] }>(url, {}, !!GET_ACTIVITY_RESPONSE_URL);
  }

  async saveActivityResponse(payload: {
    activityId: string;
    answers: Record<string, any>;
    status?: "in_progress" | "completed";
    currentStep?: number;
    currentPrompt?: number;
  }) {
    const url = SAVE_ACTIVITY_RESPONSE_URL || `${this.baseUrl}/activities/responses`;
    return this.request<{ message: string; activityId: string; insight?: string; completedAt?: string }>(
      url,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      !!SAVE_ACTIVITY_RESPONSE_URL
    );
  }

  // Student events (downloads, questions, etc.)
  async trackEvent(type: "resource_download" | "session_question", data: Record<string, any>) {
    const url = TRACK_EVENT_URL || `${this.baseUrl}/events/track`;
    // If neither is configured, fail gracefully
    if (!TRACK_EVENT_URL && !this.baseUrl) {
      return { error: "Event tracking URL not configured" };
    }
    return this.request<{ event: any }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ type, data }),
      },
      !!TRACK_EVENT_URL
    );
  }

  // Trigger Email Sequence Custom Events
  // This enrolls the current user into any ACTIVE email sequences where:
  // triggerType === "event" and triggerEvent === payload.event (normalized)
  async triggerEmailEvent(eventName: string, data?: Record<string, any>, sequenceId?: string) {
    if (!EMAIL_TRIGGER_EVENT_URL) {
      return { error: "Email trigger endpoint not configured (VITE_EMAIL_TRIGGER_EVENT_URL missing)" };
    }
    return this.request<{
      ok: boolean;
      event: string;
      matched: number;
      enrolled: string[];
      alreadyEnrolled: string[];
    }>(
      EMAIL_TRIGGER_EVENT_URL,
      {
        method: "POST",
        body: JSON.stringify({ event: eventName, data, sequenceId }),
      },
      true
    );
  }

  async listEvents(type?: "resource_download" | "session_question") {
    const baseUrl = LIST_EVENTS_URL || `${this.baseUrl}/events`;
    if (!LIST_EVENTS_URL && !this.baseUrl) {
      return { error: "Events list URL not configured" };
    }
    const url = type ? `${baseUrl}?type=${encodeURIComponent(type)}` : baseUrl;
    return this.request<{ events: any[] }>(url, {}, !!LIST_EVENTS_URL);
  }

  // Course Management
  async listCourses() {
    const baseUrl = LIST_COURSES_URL || `${this.baseUrl}/courses`;
    if (!LIST_COURSES_URL && !this.baseUrl) {
      return { error: "List courses URL not configured" };
    }
    return this.request<{ courses: any[] }>(baseUrl, {}, !!LIST_COURSES_URL);
  }

  async getCourse(courseId: string) {
    const baseUrl = GET_COURSE_URL || `${this.baseUrl}/courses/${courseId}`;
    if (!GET_COURSE_URL && !this.baseUrl) {
      return { error: "Get course URL not configured" };
    }
    const url = GET_COURSE_URL ? `${GET_COURSE_URL}?id=${courseId}` : baseUrl;
    return this.request<{ course: any }>(url, {}, !!GET_COURSE_URL);
  }

  async getUserCourses() {
    const baseUrl = GET_USER_COURSES_URL || `${this.baseUrl}/courses/user`;
    if (!GET_USER_COURSES_URL && !this.baseUrl) {
      return { error: "Get user courses URL not configured" };
    }
    return this.request<{ userCourses: any[] }>(baseUrl, {}, true);
  }


  async selectCourse(courseId: string) {
    const baseUrl = SELECT_COURSE_URL || `${this.baseUrl}/courses/select`;
    if (!SELECT_COURSE_URL && !this.baseUrl) {
      return { error: "Select course URL not configured" };
    }
    return this.request<{ message: string }>(
      baseUrl,
      {
        method: "POST",
        body: JSON.stringify({ courseId }),
      },
      true
    );
  }

  // Newsletter & Free Resources
  async subscribeNewsletter(email: string, name?: string, timezone?: string) {
    const url = SUBSCRIBE_NEWSLETTER_URL || `${this.baseUrl}/newsletter/subscribe`;
    return this.request<{ success: boolean; message: string }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ email, name, timezone }),
      },
      !!SUBSCRIBE_NEWSLETTER_URL
    );
  }

  async submitFreeResource(
    email: string,
    resourceType: string,
    newsletterConsent: boolean,
    name?: string,
    timezone?: string
  ) {
    const url = SUBMIT_FREE_RESOURCE_URL || `${this.baseUrl}/resources/free/submit`;
    return this.request<{ success: boolean; message: string }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ email, resourceType, newsletterConsent, name, timezone }),
      },
      !!SUBMIT_FREE_RESOURCE_URL
    );
  }

  async verifyFreeResource(token: string) {
    const baseUrl = VERIFY_FREE_RESOURCE_URL || `${this.baseUrl}/resources/free/verify`;
    const url = `${baseUrl}?token=${encodeURIComponent(token)}`;
    return this.request<{
      success: boolean;
      message: string;
      email?: string;
      resourceType?: string;
      accessUrl?: string;
    }>(url, {}, !!VERIFY_FREE_RESOURCE_URL);
  }

  async unsubscribeNewsletter(email: string) {
    const url = UNSUBSCRIBE_NEWSLETTER_URL || `${this.baseUrl}/newsletter/unsubscribe`;
    return this.request<{ success: boolean; message: string }>(
      url,
      {
        method: "POST", // Using POST for UI-initiated unsubscribe
        body: JSON.stringify({ email }),
      },
      !!UNSUBSCRIBE_NEWSLETTER_URL
    );
  }

  async checkResourceAccess(token: string) {
    const baseUrl = CHECK_RESOURCE_ACCESS_URL || `${this.baseUrl}/resources/free/access`;
    const url = `${baseUrl}?token=${encodeURIComponent(token)}`;
    return this.request<{
      hasAccess: boolean;
      expired?: boolean;
      email?: string;
      resourceType?: string;
      error?: string;
    }>(url, {}, !!CHECK_RESOURCE_ACCESS_URL);
  }

  async requestAccessLink(email: string, resourceType: string) {
    const url = REQUEST_ACCESS_LINK_URL || `${this.baseUrl}/resources/free/request-link`;
    return this.request<{ success: boolean; message: string }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ email, resourceType }),
      },
      !!REQUEST_ACCESS_LINK_URL
    );
  }

  // ============================================
  // Salary Edge API Methods
  // ============================================

  async createSalarySurvey(payload: {
    email: string;
    responses: {
      experience: string;
      careerTrajectory: string;
      role: string;
      companySize: string;
      workEnvironment: string;
      yearsAtCompany: string;
      techStack: string[];
      currentSalary: string;
      currency: string;
      careerIntentions: string[];
      impactAmbition: string;
      willingness: string[];
      growthBarriers: string[];
      location?: string;
    };
    subscribeToNewsletter?: boolean;
    timezone?: string;
    metadata?: any;
  }) {
    const url = SALARY_CREATE_SURVEY_URL || `${this.baseUrl}/salary-edge/survey`;
    return this.request<{
      survey: any;
      report: any;
    }>(
      url,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      !!SALARY_CREATE_SURVEY_URL
    );
  }

  async getSalarySurvey(surveyId: string) {
    const url = SALARY_GET_SURVEY_URL
      ? `${SALARY_GET_SURVEY_URL}?surveyId=${surveyId}`
      : `${this.baseUrl}/salary-edge/survey/${surveyId}`;
    return this.request<{ survey: any }>(url, {}, !!SALARY_GET_SURVEY_URL);
  }

  async getSalarySurveysByEmail(email: string) {
    const url = SALARY_GET_SURVEYS_BY_EMAIL_URL
      ? `${SALARY_GET_SURVEYS_BY_EMAIL_URL}?email=${encodeURIComponent(email)}`
      : `${this.baseUrl}/salary-edge/surveys/by-email?email=${encodeURIComponent(email)}`;
    return this.request<{ surveys: any[] }>(url, {}, !!SALARY_GET_SURVEYS_BY_EMAIL_URL);
  }

  async getSalarySurveysByUser() {
    const url = SALARY_GET_SURVEYS_BY_USER_URL || `${this.baseUrl}/salary-edge/surveys/by-user`;
    return this.request<{ surveys: any[] }>(url, {}, !!SALARY_GET_SURVEYS_BY_USER_URL);
  }

  async linkSalarySurveys(email: string) {
    const url = SALARY_LINK_SURVEYS_URL || `${this.baseUrl}/salary-edge/surveys/link`;
    return this.request<{ linked: number; message: string }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ email }),
      },
      !!SALARY_LINK_SURVEYS_URL
    );
  }

  async generateSalaryReport(surveyId: string, type: "free" | "premium" = "free") {
    const url = SALARY_GENERATE_REPORT_URL || `${this.baseUrl}/salary-edge/report/generate`;
    return this.request<{
      report: any;
      hasPremiumAccess: boolean;
    }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ surveyId, type }),
      },
      !!SALARY_GENERATE_REPORT_URL
    );
  }

  async refineSalaryReport(reportId: string, focus: string, aspiration: string, obstacles?: string) {
    const url = SALARY_REFINE_REPORT_URL || `${this.baseUrl}/salary-edge/report/refine`;
    return this.request<{
      success: boolean;
      report: any;
    }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ reportId, focus, aspiration, obstacles }),
      },
      !!SALARY_REFINE_REPORT_URL
    );
  }

  async getSalaryReport(reportId: string, accessKey?: string | null, shallow: boolean = false) {
    let url = SALARY_GET_REPORT_URL
      ? `${SALARY_GET_REPORT_URL}?reportId=${reportId}`
      : `${this.baseUrl}/salary-edge/report/${reportId}`;

    if (accessKey) {
      url += (url.includes('?') ? '&' : '?') + `key=${accessKey}`;
    }

    if (shallow) {
      url += (url.includes('?') ? '&' : '?') + `shallow=true`;
    }

    return this.request<{
      report: any;
      aiGenerationStatus?: string;
      hasPremiumAccess: boolean;
    }>(url, {}, !!SALARY_GET_REPORT_URL);
  }

  async resendSalaryReportLink(email: string, reportId: string) {
    const url = SALARY_RESEND_EMAIL_URL || `${this.baseUrl}/salary-edge/report/resend`;
    return this.request<{ message: string }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ email, reportId }),
      },
      !!SALARY_RESEND_EMAIL_URL
    );
  }

  async getSalaryReportsByUser() {
    const url = SALARY_GET_REPORTS_BY_USER_URL || `${this.baseUrl}/salary-edge/reports/by-user`;
    return this.request<{ reports: any[] }>(url, {}, !!SALARY_GET_REPORTS_BY_USER_URL);
  }

  async savePartialSalarySurvey(payload: {
    email: string;
    currentStep: number;
    responses: Record<string, any>;
  }) {
    const url = SALARY_SAVE_PARTIAL_URL || `${this.baseUrl}/salary-edge/survey/partial`;
    return this.request<{ id: string; resumeToken: string }>(
      url,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      !!SALARY_SAVE_PARTIAL_URL
    );
  }

  async resumeSalarySurvey(token: string) {
    const url = SALARY_RESUME_SURVEY_URL
      ? `${SALARY_RESUME_SURVEY_URL}?token=${token}`
      : `${this.baseUrl}/salary-edge/survey/resume?token=${token}`;
    return this.request<{
      id: string;
      email: string;
      currentStep: number;
      responses: Record<string, any>;
    }>(url, {}, !!SALARY_RESUME_SURVEY_URL);
  }

  async getAIUsage(hours: number = 24) {
    const url = ADMIN_GET_AI_USAGE_URL || `${this.baseUrl}/admin/ai-usage`;
    return this.request<{ usage: any[]; stats: any }>(
      `${url}?hours=${hours}`,
      {},
      !!ADMIN_GET_AI_USAGE_URL
    );
  }

  // ============================================
  // Survey Response Tracking API Methods
  // ============================================

  async submitSurveyResponse(payload: {
    email: string;
    surveyType: string;
    surveyVersion?: string;
    resultId: string;
    resultLabel: string;
    scores?: Record<string, number>;
    responses: Record<string, any>;
    questionAnswers?: Array<{
      questionId: string;
      questionText: string;
      answerValue: string | string[] | number;
      answerScore?: number;
      dimension?: string;
      timeSpentSeconds?: number;
    }>;
    completionTimeSeconds?: number;
    startedAt?: string;
    metadata?: Record<string, any>;
  }) {
    const url = SUBMIT_SURVEY_RESPONSE_URL || `${this.baseUrl}/survey-responses`;
    return this.request<{
      response: any;
      profileInsights?: any;
    }>(
      url,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      !!SUBMIT_SURVEY_RESPONSE_URL
    );
  }

  // Get authenticated user's own survey responses
  async getSurveyResponses(surveyType?: string) {
    const baseUrl = GET_SURVEY_RESPONSES_URL || `${this.baseUrl}/survey-responses/user`;
    const url = surveyType
      ? `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}surveyType=${encodeURIComponent(surveyType)}`
      : baseUrl;
    return this.request<{
      responses: any[];
      total: number;
    }>(url, {}, !!GET_SURVEY_RESPONSES_URL);
  }

  // Get authenticated user's own profile insights
  async getUserProfileInsights() {
    const url = GET_USER_PROFILE_INSIGHTS_URL || `${this.baseUrl}/user-profile-insights`;
    return this.request<{
      insights: any;
    }>(url, {}, !!GET_USER_PROFILE_INSIGHTS_URL);
  }

  // Link anonymous survey responses to authenticated user (when they login)
  async linkSurveyResponses(email: string) {
    const url = LINK_SURVEY_RESPONSES_URL || `${this.baseUrl}/survey-responses/link`;
    return this.request<{
      linked: number;
      message: string;
    }>(
      url,
      {
        method: "POST",
        body: JSON.stringify({ email }),
      },
      !!LINK_SURVEY_RESPONSES_URL
    );
  }

  // ============================================
  // Admin-Only Survey Response Methods
  // ============================================

  // Admin: Get all survey responses with filtering (requires admin auth)
  async adminGetAllSurveyResponses(filters?: {
    email?: string;
    surveyType?: string;
    limit?: number;
    offset?: number;
  }) {
    const baseUrl = ADMIN_GET_ALL_SURVEY_RESPONSES_URL || `${this.baseUrl}/admin/survey-responses`;
    const params = new URLSearchParams();
    if (filters?.email) params.append('email', filters.email);
    if (filters?.surveyType) params.append('surveyType', filters.surveyType);
    if (filters?.limit) params.append('limit', filters.limit.toString());
    if (filters?.offset) params.append('offset', filters.offset.toString());

    const url = params.toString() ? `${baseUrl}?${params.toString()}` : baseUrl;
    return this.request<{
      responses: any[];
      total: number;
      stats: {
        total: number;
        archetypeInsight: number;
        aiCareerCompass: number;
        salaryEdge: number;
        uniqueUsers: number;
      };
    }>(url, {}, !!ADMIN_GET_ALL_SURVEY_RESPONSES_URL);
  }

  // Admin: Get survey responses by email (requires admin auth)
  async adminGetSurveyResponsesByEmail(email: string, surveyType?: string) {
    const baseUrl = ADMIN_GET_SURVEY_RESPONSES_BY_EMAIL_URL || `${this.baseUrl}/admin/survey-responses/by-email`;
    let url = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}email=${encodeURIComponent(email)}`;
    if (surveyType) {
      url += `&surveyType=${encodeURIComponent(surveyType)}`;
    }
    return this.request<{
      responses: any[];
      total: number;
    }>(url, {}, !!ADMIN_GET_SURVEY_RESPONSES_BY_EMAIL_URL);
  }

  // Admin: Get user profile insights by email (requires admin auth)
  async adminGetProfileInsightsByEmail(email: string) {
    const baseUrl = ADMIN_GET_PROFILE_INSIGHTS_BY_EMAIL_URL || `${this.baseUrl}/admin/user-profile-insights/by-email`;
    const url = `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}email=${encodeURIComponent(email)}`;
    return this.request<{
      insights: any;
    }>(url, {}, !!ADMIN_GET_PROFILE_INSIGHTS_BY_EMAIL_URL);
  }
}

// Export singleton instance
export const api = new ApiClient(API_BASE_URL);
